const en = {
  nav: {
    work: 'Work',
    clients: 'Clients',
    about: 'About',
    writing: 'Writing',
    contact: 'Contact',
    photos: 'Photos',
    home: 'Home',
    menu: 'Menu',
    open: 'Open to remote roles',
    themeLabel: 'Switch theme',
  },
  hero: {
    eyebrow: 'Backend-focused full stack developer',
    h1: 'Hi, I’m Furkan.',
    h1b: 'From idea to product, and beyond.',
    p: 'I think before I code, plan with the client, build with AI agents under my review, test, ship, and keep improving after launch.',
    seeWork: 'See the work ↓',
    resume: 'Resume ↗',
    stageLabel: 'From idea to product, and beyond',
  },
  proof: {
    eyebrow: '(01) Proof',
    heading: 'Measured, not claimed.',
    p1l: '01 · accuracy',
    p1d: 'valid questions passed to the assistant, none wrongly blocked',
    p2l: '02 · latency',
    p2d: 'faster pre-check (~0.4 s) than a full model answer (~60 s)',
    p3l: '03 · funding',
    p3d: 'TÜBİTAK research funding, won as co-founder',
    p4l: '04 · shipped',
    p4u: ' live',
    p4d: 'client sites in production, each with a custom admin panel',
  },
  work: {
    eyebrow: '(02) Selected work',
    heading: 'The product on the surface.',
    heading2: 'The system underneath.',
    clientEyebrow: '(03) Client work',
    clientHeading: 'Live in production.',
    clientHeading2: 'Built and run end to end.',
    role: 'Role',
    caseStudy: 'Case study →',
    live: 'Live ↗',
    product: 'Product',
    hood: 'Under the hood',
    replay: '↻ Replay',
    stackLbl: 'stack',
    project: 'Project',
    loading: 'Loading projects...',
    error: 'Projects could not be loaded.',
  },
  studies: {
    eyebrow: '(04) UI studies',
    heading: 'Motion and detail,',
    heading2: 'for practice.',
  },
  about: {
    eyebrow: '(05) About',
    sub: 'Computer Engineering, Pamukkale University',
    p1: 'I started on the network side, configuring switches and firewalls, and moved up the stack into software.',
    p2: 'That path shapes how I build: where does the request go, what can fail along the way, and how do I prove it works?',
    skills: [
      ['Backend', 'Go, Python, Django REST, PostgreSQL, Redis'],
      ['Frontend', 'TypeScript, React, Next.js, Vue'],
      ['Infra & network', 'Linux, Docker, Nginx, CI/CD, Cisco & Huawei, FortiGate, F5 WAF'],
    ],
    experience: 'Experience',
    jobs: [
      ['2026', 'Technology Intern', 'ATİLAB · Istanbul'],
      ['2026 — now', 'Co-Founder & Full-Stack Developer', 'KeyStrada · PropTech'],
      ['2025', 'IT Network Intern', 'TOFAŞ · Bursa'],
      ['2024 — now', 'Full-Stack Developer · Freelance', 'Remote'],
      ['2024', 'Erasmus+ Student', 'Međimurje University · Croatia'],
      ['2022 — 2026', 'B.Sc. Computer Engineering', 'Pamukkale University'],
    ],
  },
  writing: {
    eyebrow: '(06) Writing',
    allPosts: 'All posts →',
  },
  contact: {
    eyebrow: '(07) Contact',
    heading: 'Need a system that holds up?',
    heading2: 'Let’s talk.',
  },
  footer: {
    built: 'Built in Bursa',
  },
  photos: {
    eyebrow: 'Photos',
    heading: 'My Recent Travels',
    loading: 'Loading photos...',
    error: 'Photos could not be loaded.',
    photosLabel: 'photos',
    noPhotosFound: 'No photos found.',
  },
  blog: {
    eyebrow: 'Writing',
    heading: 'Blog',
    subheading: 'My personal reflections about software development and more.',
    postsLabel: 'posts',
    backToBlog: 'Back to Blog',
    noPostsFound: 'No posts found.',
    loading: 'Loading...',
    error: 'Posts could not be loaded.',
    allCategories: 'All',
    pageOf: 'Page {page} of {total}',
    previous: 'Previous',
    next: 'Next',
  },
};

export default en;
